import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import i18n from "../../../../constants/i18n";
import Et3Table from "../../../../core/et3-table";
import { AUDITOR_USER_RATE_US_DATA_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import getUserRateUsStore from "../../../../stores/auditor-store/user-rate-us-store";

const UserRateUsData = withLiteObserverAndTheme(() => {
  const ratingsData = getUserRateUsStore().rateUsData.get();

  return (
    <Et3Table
      columns={AUDITOR_USER_RATE_US_DATA_HEADERS}
      rows={ratingsData}
      title={i18n.get("USER_RATE_US_DATA")}
      shouldBeFlagged={false}
      titleKey={"USER_RATE_US_DATA"}
    />
  );
});
export default UserRateUsData;
